import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './SummaryCard.module.scss';

type Props = {
  label: string;
  value: ReactNode;
  secondary?: ReactNode;
  /** Top-right actions slot (e.g. a preview icon button). Stays clickable even
   * when the card is a link. */
  actions?: ReactNode;
  /** When provided, the whole card becomes a link to this in-app route (via a
   * stretched link covering the card), while `actions` remain independently
   * clickable. */
  to?: string;
  className?: string;
  'data-testid'?: string;
};

/**
 * Compact summary card used on the run results page for the Evaluation Source
 * and Run Schedule blocks: an uppercase label, a large primary value, an
 * optional secondary line, and a top-right actions slot. When `to` is set the
 * entire card is clickable (stretched link over the value).
 */
export function SummaryCard( { label, value, secondary, actions, to, className, 'data-testid': dataTestId }: Props ) {
  return (
    <section className={ clsx( styles.card, to && styles.card_clickable, className ) } data-testid={ dataTestId }>
      <div className={ styles.header }>
        <span className={ styles.label }>{ label }</span>
        { actions && <div className={ styles.actions }>{ actions }</div> }
      </div>
      <div className={ styles.value }>
        { to ? <Link to={ to } className={ styles.stretched_link }>{ value }</Link> : value }
      </div>
      { secondary && <div className={ styles.secondary }>{ secondary }</div> }
    </section>
  );
}
